import { ErrorManagement } from '@printdeal/error-management/react';
import Api from '../Api';
import { windowPresent } from '../../helpers/window';

const getBaseUrlWithPath = (): string => {
  if (!windowPresent) return '';
  const { origin, pathname } = new URL(window.location.href);
  return origin + pathname;
};

type TechnicalDrawingFileUrl = { fileName: string; resultUrl: string; pollingUrl: string };

type TechnicalDrawingInProgress = {
  status: 'IN_PROGRESS';
};

export type TechnicalDrawingReady = {
  status?: 'READY';
  ai: TechnicalDrawingFileUrl;
  pdf: TechnicalDrawingFileUrl;
  independentInstructions: TechnicalDrawingFileUrl[];
};

export type TechnicalDrawingTemplateResponse = TechnicalDrawingInProgress | TechnicalDrawingReady;

class SurfaceDependencyService extends Api {
  getTechnicalDrawingPdfUrl = async (
    productId: string,
    productName: string,
    selections: { [key: string]: string },
    locale: string,
    version?: number,
  ): Promise<TechnicalDrawingTemplateResponse> => {
    try {
      const url = getBaseUrlWithPath();
      const { data } = await this.httpClient.post<TechnicalDrawingTemplateResponse>(
        '/v2/templates',
        {
          productId,
          version,
          selections: {
            ...selections,
            product_loc_name: productName,
            product_loc_pdp: url,
          },
          accountId: 'noS5wU4XH2WRmkaqKqTpfH',
          templateParameters: {
            requiredFiles: ['ai', 'pdf', 'independentInstructions'],
            outputFormat: 'link',
            locale,
          },
        },
      );
      return data;
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        extra: {
          productId,
          version,
          selections: JSON.stringify(selections),
        },
        tags: {
          component: 'summary',
          fileLocation: 'SurfaceDependencyService.ts',
          featureFunction: 'getTechnicalDrawingPdfUrl',
        },
        fingerprint: ['printdeal-pdf-template-download'],
      });
      throw error;
    }
  };
}

export default SurfaceDependencyService;
